import { render, staticRenderFns } from "./ExportWrapper.vue?vue&type=template&id=24fb0d20&"
import script from "./ExportWrapper.vue?vue&type=script&lang=ts&"
export * from "./ExportWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/builds/riverline/optincollect-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24fb0d20')) {
      api.createRecord('24fb0d20', component.options)
    } else {
      api.reload('24fb0d20', component.options)
    }
    module.hot.accept("./ExportWrapper.vue?vue&type=template&id=24fb0d20&", function () {
      api.rerender('24fb0d20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/campaign/ExportWrapper.vue"
export default component.exports